import { useEffect } from 'react';
import ReactGA from 'react-ga4';

import { useLoggedUserInfo } from './queries';

const useInitializeGoogleAnalytics = () => {
    useEffect(() => {
        const trackingId = import.meta.env.VITE_GOOGLE_ANALYTICS_TAG_ID;
        if (!trackingId) return;

        ReactGA.initialize(trackingId);
    }, []);
};

const useSetGaDepartment = () => {
    const { data: user, isSuccess } = useLoggedUserInfo();

    useEffect(() => {
        if (!isSuccess || !user?.departmentCode) return;

        ReactGA.gtag('set', 'user_properties', {
            user_department_code: `D_${user.departmentCode}`,
        });
    }, [isSuccess, user?.departmentCode]);
};

export const useGoogleAnalytics = () => {
    useInitializeGoogleAnalytics();
    useSetGaDepartment();
};
